function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, ".looking-around_svg__st1{fill:#819ad0}.looking-around_svg__st2{fill:#3f3d56}.looking-around_svg__st3{fill:#f2f2f2}.looking-around_svg__st4{fill:#2f2e41}");

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 206.4,
  cy: 389.9,
  rx: 176.4,
  ry: 17.1,
  opacity: 0.1,
  fill: "#2f2e41"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "looking-around_svg__st1",
  cx: 577.1,
  cy: 186.1,
  r: 72
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "looking-around_svg__st2",
  d: "M498.8 110.1c16.6 17 42.1 19.1 42.1 19.1s-1.4-25.5-18-42.5-42.1-19.1-42.1-19.1 1.4 25.5 18 42.5z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "looking-around_svg__st1",
  d: "M504.3 101.4c22.9 6.2 37.2 27.4 37.2 27.4s-23 11.2-45.9 5c-22.9-6.2-37.2-27.4-37.2-27.4s23-11.2 45.9-5z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "looking-around_svg__st2",
  d: "M526.8 85.1c.2 23.8 17.1 42.9 17.1 42.9s16.7-19.4 16.5-43.1-17-42.9-17-42.9-16.7 19.4-16.6 43.1z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "looking-around_svg__st1",
  d: "M536.9 82.7c12.2 20.4 7.8 45.5 7.8 45.5s-24.3-7.9-36.6-28.2-7.8-45.5-7.8-45.5 24.4 7.8 36.6 28.2z"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "looking-around_svg__st3",
  cx: 570.6,
  cy: 180.5,
  r: 37
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "looking-around_svg__st2",
  cx: 553.3,
  cy: 192,
  r: 12
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  className: "looking-around_svg__st1",
  cx: 208,
  cy: 317.9,
  r: 72
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "looking-around_svg__st2",
  d: "M176.6 213.4c6.2 22.9 27.5 37.1 27.5 37.1s11.2-23 5-45.9-27.5-37.1-27.5-37.1-11.2 22.9-5 45.9z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "looking-around_svg__st1",
  d: "M185.7 208.5c17 16.6 19.1 42.1 19.1 42.1s-25.5-1.4-42.6-18-19.1-42.1-19.1-42.1 25.6 1.4 42.6 18z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "looking-around_svg__st2",
  d: "M213.3 205.2c-11.4 20.8-6 45.8-6 45.8s24-8.8 35.4-29.6 6-45.8 6-45.8-24 8.8-35.4 29.6z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "looking-around_svg__st1",
  d: "M223.2 208c.8 23.8-15.4 43.6-15.4 43.6s-17.4-18.7-18.2-42.5 15.4-43.6 15.4-43.6 17.5 18.8 18.2 42.5z"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  className: "looking-around_svg__st3",
  cx: 205,
  cy: 309.9,
  r: 37
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  className: "looking-around_svg__st2",
  cx: 217,
  cy: 291.9,
  r: 12
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "looking-around_svg__st4",
  d: "M95.9 390.3l-1.8-.9c23.1-44.6 10.7-102.6-3.7-143.3-9.8-27.4-22.3-53.7-37.3-78.7l1.7-1.1c15.1 25.1 27.6 51.5 37.5 79.1 14.6 41.1 27 99.7 3.6 144.9z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-79.642 107.507 202.377)",
  className: "looking-around_svg__st4",
  d: "M71.4 201.4h72.2v2H71.4z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-42.937 59.509 263.881)",
  className: "looking-around_svg__st4",
  d: "M58.5 214.7h2v98.4h-2z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-54.139 130.998 330.377)",
  className: "looking-around_svg__st4",
  d: "M102 329.4h58v2h-58z"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  className: "looking-around_svg__st1",
  cx: 119,
  cy: 137.9,
  r: 10
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  className: "looking-around_svg__st2",
  cx: 10,
  cy: 214.9,
  r: 10
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  className: "looking-around_svg__st2",
  cx: 54,
  cy: 224.9,
  r: 10
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  className: "looking-around_svg__st1",
  cx: 34,
  cy: 263.9,
  r: 10
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  className: "looking-around_svg__st2",
  cx: 159,
  cy: 288.9,
  r: 10
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  className: "looking-around_svg__st2",
  cx: 126,
  cy: 299.9,
  r: 10
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  className: "looking-around_svg__st2",
  cx: 149,
  cy: 331.9,
  r: 10
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  className: "looking-around_svg__st2",
  cx: 44,
  cy: 149.9,
  r: 10
});

function SvgLookingAround(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "looking-around_svg__b353ec75-bcce-4419-97dd-3622db29ecf5",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 752.6 407",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
}

export default "data:image/svg+xml;base64,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";
export { SvgLookingAround as ReactComponent };